interface Serie {
  title: string,
  image: string,
}

const seriesData: Serie[] = [
  {
    title: 'Black Mirror',
    image: 'black-mirror-thumb.jpg'
  },
  {
    title: 'How To Get Away With Murder',
    image: 'htgawm-thumb.jpg'
  },
  {
    title: 'Orphan Black',
    image: 'orphan-black-thumb.jpg'
  },
  {
    title: 'The Sinner',
    image: 'the-sinner-thumb.jpg'
  },
  {
    title: 'Stranger Things',
    image: 'stranger-things-thumb.jpg'
  },
  {
    title: 'Love, Death + Robots',
    image: 'LDR-thumb.jpg'
  },
  {
    title: 'Lucifer',
    image: 'lucifer-thumbnail.jpg'
  }
]

export default seriesData
